import { APP_CONFIG } from "../../constants/constants";

const ScreenComplianceAdmin = () => {

  return (
    <>
      <div className={`${APP_CONFIG.DES.DASH.P_HORIZ} py-2 min-h-screen-excl-header Xbg-black/20 flex flex-col`}>
        <iframe
          className="flex-1 w-full border-0"
          src={APP_CONFIG.COMPLIANCE_ADMIN_URL}
        />
      </div>
    </>
  )
}
export default ScreenComplianceAdmin;